import { globalStyleObj } from "@/app/assets/styles";
import {
  LabelText,
  NormalBrowseFileInputFiled,
  NormalMultipleFixedInputFields,
  NormalTextInputField,
  RepeatableMultipleInputStackFilds,
} from "@/components";
import { Skeleton } from "@/components/ui/skeleton";
import React, { useMemo } from "react";
import { MdOutlineDeleteForever } from "react-icons/md";

const AboutUsSecondTabCMSFormFields = ({
  activeTab,
  selectedTab,
  isFetching,
  formData,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleImageChange,
  addOnlyValueRepeaterChange,
  removeOnlyValueRepeaterChange,
  updateOnlyValueRepeaterChange,
  addMultiValueRepeaterChange,
  removeMultiValueRepeaterChange,
  updateMultiValueRepeaterChange,
  adminRole,
  permissionsList,
  colorGrade,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {/* --- Benefit Section Fields --- */}
      {selectedTab === "section-1" && (
        <>
          {/* Page Short Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Page Short Description"
            fieldId="about-fujairah-freezone-page-short-description"
            fieldName="about-fujairah-freezone-page-short-description"
            placeholderText="Page Short Description"
            inputValue={
              formData?.["about-fujairah-freezone-page-short-description"] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Benefit Section Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Benefit Image"
              fieldId="about-fujairah-freezone-benefit-section-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange(
                      "about-fujairah-freezone-benefit-section-image",
                      id
                    )
                  : handleImageChange(
                      "about-fujairah-freezone-benefit-section-image",
                      ""
                    )
              }
              selectedFileId={
                formData?.["about-fujairah-freezone-benefit-section-image"] ||
                ""
              }
              adminRole={adminRole}
              permissionsList={permissionsList}
              extraContainerClasses="mt-5"
            />
          )}

          {/* Benefit Section Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Benefit Heading"
            fieldId="about-fujairah-freezone-benefit-section-heading"
            fieldName="about-fujairah-freezone-benefit-section-heading"
            placeholderText="Benefit Heading"
            inputValue={
              formData?.["about-fujairah-freezone-benefit-section-heading"] ||
              ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Multiple Benefit Key Points */}
          <div className="w-full mt-5 flex flex-col gap-2 xl:flex-row justify-between lg:gap-5">
            {isFetching ? (
              <Skeleton className="w-[150px] h-[30px] rounded-md" />
            ) : (
              <LabelText
                text="Benefit Key Points"
                htmlForId="about-fujairah-freezone-benefit-section-key-points"
                star={false}
                translateField={true}
              />
            )}

            <div className="w-full lg:max-w-[500px]">
              {formData?.[
                "about-fujairah-freezone-benefit-section-key-points"
              ] &&
                formData?.["about-fujairah-freezone-benefit-section-key-points"]
                  .length > 0 && (
                  <div className="w-full">
                    {formData?.[
                      "about-fujairah-freezone-benefit-section-key-points"
                    ].map((item, index) => (
                      <div key={index} className="w-full flex gap-2 mb-5">
                        {isFetching ? (
                          <Skeleton className="w-full flex-1 h-[40px] rounded-md" />
                        ) : (
                          <NormalTextInputField
                            isFetching={isFetching}
                            fieldId={`about-fujairah-freezone-benefit-section-key-point-${activeTab}-${index}`}
                            // fieldName="home-section-1-banner-heading"
                            placeholderText={`Key Point ${index + 1}`}
                            inputValue={
                              formData?.[
                                "about-fujairah-freezone-benefit-section-key-points"
                              ]?.[index] || ""
                            }
                            onChangeTextInputField={(e) =>
                              updateOnlyValueRepeaterChange(
                                "about-fujairah-freezone-benefit-section-key-points",
                                index,
                                e.target.value
                              )
                            }
                            extraContainerClasses="w-full"
                            // translateField={true}
                            // extraContainerClasses="mt-5"
                          />
                        )}

                        {isFetching ? (
                          <Skeleton className="w-[30px] h-[40px] rounded-md" />
                        ) : (
                          <button
                            type="button"
                            onClick={() =>
                              removeOnlyValueRepeaterChange(
                                "about-fujairah-freezone-benefit-section-key-points",
                                index
                              )
                            }
                            className="flex justify-center items-start"
                          >
                            <MdOutlineDeleteForever
                              size={25}
                              className="text-red-500 hover:scale-[1.2] transition-300"
                            />
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                )}

              {isFetching ? (
                <Skeleton className="w-[120px] h-[40px] rounded-md" />
              ) : (
                <button
                  type="button"
                  onClick={() =>
                    addOnlyValueRepeaterChange(
                      "about-fujairah-freezone-benefit-section-key-points"
                    )
                  }
                  className={`${globalStyleObj.flexCenter} transition-300 gap-2 rounded-[4px] ${colorGrade.bgColor} ${colorGrade.hoverBgColor} ${colorGrade.textColor} px-5 py-2 font-poppins-rg text-[13px] tracking-wide hover:text-white w-full sm:max-w-[120px] dark:text-light-weight-800`}
                >
                  Add
                </button>
              )}
            </div>
          </div>

          {/* Multi Benefit Stats */}
          <RepeatableMultipleInputStackFilds
            stateDetails={formData}
            isFetching={isFetching}
            allFilesResponse={allFilesResponse}
            labelText="Benefit Stats"
            fieldId="about-fujairah-freezone-benefit-section-stats"
            fieldKey="about-fujairah-freezone-benefit-section-stats"
            searchValue={searchValue}
            selectedFileType={selectedFileType}
            adminRole={adminRole}
            permissionsList={permissionsList}
            addMultiValueRepeaterChange={addMultiValueRepeaterChange}
            removeMultiValueRepeaterChange={removeMultiValueRepeaterChange}
            updateMultiValueRepeaterChange={updateMultiValueRepeaterChange}
            translateField={true}
            extraContainerClasses="mt-5"
            filedStructure={["TEXT", "TEXT", "TEXT_AREA"]}
            dataStructure={{ title: "", countText: "", description: "" }}
            placeholderTexts={[
              "Stats Title",
              "Stats Count Text",
              "Stats Description",
            ]}
            colorGrade={colorGrade}
            extraContainerClasses="mt-5"
          />
        </>
      )}

      {/* --- Our History Section Fields --- */}
      {selectedTab === "section-2" && (
        <>
          {/* History Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Heading"
            fieldId="about-fujairah-freezone-our-history-section-heading"
            fieldName="about-fujairah-freezone-our-history-section-heading"
            placeholderText="Heading"
            inputValue={
              formData?.[
                "about-fujairah-freezone-our-history-section-heading"
              ] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            // extraContainerClasses="mt-5"
          />

          {/* History Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Description"
            fieldId="about-fujairah-freezone-our-history-section-description"
            fieldName="about-fujairah-freezone-our-history-section-description"
            placeholderText="Description"
            inputValue={
              formData?.[
                "about-fujairah-freezone-our-history-section-description"
              ] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Card Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Card Heading"
            fieldId="about-fujairah-freezone-our-history-section-card-heading"
            fieldName="about-fujairah-freezone-our-history-section-card-heading"
            placeholderText="Card Heading"
            inputValue={
              formData?.[
                "about-fujairah-freezone-our-history-section-card-heading"
              ] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Card Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Card Description"
            fieldId="about-fujairah-freezone-our-history-section-card-description"
            fieldName="about-fujairah-freezone-our-history-section-card-description"
            placeholderText="Card Description"
            inputValue={
              formData?.[
                "about-fujairah-freezone-our-history-section-card-description"
              ] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Card Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Card Image"
              fieldId="about-fujairah-freezone-our-history-section-card-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange(
                      "about-fujairah-freezone-our-history-section-card-image",
                      id
                    )
                  : handleImageChange(
                      "about-fujairah-freezone-our-history-section-card-image",
                      ""
                    )
              }
              selectedFileId={
                formData?.[
                  "about-fujairah-freezone-our-history-section-card-image"
                ] || ""
              }
              adminRole={adminRole}
              permissionsList={permissionsList}
              extraContainerClasses="mt-5"
            />
          )}
        </>
      )}

      {/* --- WCU Section Fields --- */}
      {selectedTab === "section-3" && (
        <>
          {/* WCU Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Heading"
            fieldId="about-fujairah-freezone-wcu-section-heading"
            fieldName="about-fujairah-freezone-wcu-section-heading"
            placeholderText="Heading"
            inputValue={
              formData?.["about-fujairah-freezone-wcu-section-heading"] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* WCU Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Description"
            fieldId="about-fujairah-freezone-wcu-section-description"
            fieldName="about-fujairah-freezone-wcu-section-description"
            placeholderText="Description"
            inputValue={
              formData?.["about-fujairah-freezone-wcu-section-description"] ||
              ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* WCU Key Points */}
          <NormalMultipleFixedInputFields
            stateDetails={formData}
            isFetching={isFetching}
            allFilesResponse={allFilesResponse}
            labelText="Key Points"
            fieldId="about-fujairah-freezone-wcu-section-key-points"
            searchValue={searchValue}
            selectedFileType={selectedFileType}
            adminRole={adminRole}
            permissionsList={permissionsList}
            handleImageChange={handleImageChange}
            handleTextInputChange={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
            cards={[
              {
                card_id: "about-fujairah-freezone-wcu-section-key-card-1",
                types: ["IMAGE", "TEXT", "TEXT_AREA"],
                is_hidden: [isHideInOtherLanguages, true, true],
                ids_name: [
                  "logo_field_id",
                  "text_filed_id",
                  "text_area_field_id",
                ],
                placeholders_name: [
                  "",
                  "text_filed_placeholder",
                  "text_area_filed_placeholder",
                ],
                // IDs
                logo_field_id:
                  "about-fujairah-freezone-wcu-section-key-card-logo-1",
                text_filed_id:
                  "about-fujairah-freezone-wcu-section-key-card-title-1",
                text_area_field_id:
                  "about-fujairah-freezone-wcu-section-key-card-description-1",
                // Placeholders
                text_filed_placeholder: "Title",
                text_area_filed_placeholder: "Description",
              },
              {
                card_id: "about-fujairah-freezone-wcu-section-key-card-2",
                types: ["IMAGE", "TEXT", "TEXT_AREA"],
                is_hidden: [isHideInOtherLanguages, true, true],
                ids_name: [
                  "logo_field_id",
                  "text_filed_id",
                  "text_area_field_id",
                ],
                placeholders_name: [
                  "",
                  "text_filed_placeholder",
                  "text_area_filed_placeholder",
                ],
                // IDs
                logo_field_id:
                  "about-fujairah-freezone-wcu-section-key-card-logo-2",
                text_filed_id:
                  "about-fujairah-freezone-wcu-section-key-card-title-2",
                text_area_field_id:
                  "about-fujairah-freezone-wcu-section-key-card-description-2",
                // Placeholders
                text_filed_placeholder: "Title",
                text_area_filed_placeholder: "Description",
              },
              {
                card_id: "about-fujairah-freezone-wcu-section-key-card-3",
                types: ["IMAGE", "TEXT", "TEXT_AREA"],
                is_hidden: [isHideInOtherLanguages, true, true],
                ids_name: [
                  "logo_field_id",
                  "text_filed_id",
                  "text_area_field_id",
                ],
                placeholders_name: [
                  "",
                  "text_filed_placeholder",
                  "text_area_filed_placeholder",
                ],
                // IDs
                logo_field_id:
                  "about-fujairah-freezone-wcu-section-key-card-logo-3",
                text_filed_id:
                  "about-fujairah-freezone-wcu-section-key-card-title-3",
                text_area_field_id:
                  "about-fujairah-freezone-wcu-section-key-card-description-3",
                // Placeholders
                text_filed_placeholder: "Title",
                text_area_filed_placeholder: "Description",
              },
              {
                card_id: "about-fujairah-freezone-wcu-section-key-card-4",
                types: ["IMAGE", "TEXT", "TEXT_AREA"],
                is_hidden: [isHideInOtherLanguages, true, true],
                ids_name: [
                  "logo_field_id",
                  "text_filed_id",
                  "text_area_field_id",
                ],
                placeholders_name: [
                  "",
                  "text_filed_placeholder",
                  "text_area_filed_placeholder",
                ],
                // IDs
                logo_field_id:
                  "about-fujairah-freezone-wcu-section-key-card-logo-4",
                text_filed_id:
                  "about-fujairah-freezone-wcu-section-key-card-title-4",
                text_area_field_id:
                  "about-fujairah-freezone-wcu-section-key-card-description-4",
                // Placeholders
                text_filed_placeholder: "Title",
                text_area_filed_placeholder: "Description",
              },
              {
                card_id: "about-fujairah-freezone-wcu-section-key-card-5",
                types: ["IMAGE", "TEXT", "TEXT_AREA"],
                is_hidden: [isHideInOtherLanguages, true, true],
                ids_name: [
                  "logo_field_id",
                  "text_filed_id",
                  "text_area_field_id",
                ],
                placeholders_name: [
                  "",
                  "text_filed_placeholder",
                  "text_area_filed_placeholder",
                ],
                // IDs
                logo_field_id:
                  "about-fujairah-freezone-wcu-section-key-card-logo-5",
                text_filed_id:
                  "about-fujairah-freezone-wcu-section-key-card-title-5",
                text_area_field_id:
                  "about-fujairah-freezone-wcu-section-key-card-description-5",
                // Placeholders
                text_filed_placeholder: "Title",
                text_area_filed_placeholder: "Description",
              },
            ]}
          />
        </>
      )}
    </>
  );
};

export default AboutUsSecondTabCMSFormFields;
